import * as React from "react";
import Skeleton from "@mui/material/Skeleton";

export function SkeletonDahsboard({ width, height, variant }) {
  return (
    <>
      <Skeleton variant={variant} width={width} height={height} />
    </>
  );
}
